module.exports = __webpack_public_path__ + "assets/img/PEN.webp?b3c81d68fe92389e50c083eb78d624c4";